export default __webpack_public_path__ + "static/media/Montserrat-Bold.733964aa.ttf";